<template>
    <transition name="fade">
        <div class="lightbox" v-if="isOpen">

            <div class="lightbox-modal" v-if="isOpen">
                <div class="lightbox-close" v-on:click="close">&times;</div>
                <div class="lightbox-body">
                    <slot></slot>
                </div>
            </div>

        </div>
    </transition>
</template>

<script>
module.exports = {
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {

        }
    },
    methods: {
        close() {
            this.$emit('close');
        }
    },
    mounted() {
        $(document).keyup((e) => {
             if (e.key === "Escape") {
                this.close();
            }
        });
    },
    beforeDestroy() {
        // $(document).unbind('keyup');
    }
};
</script>